import { useMemo } from "react"
import { IQuickAnswersContextValue } from "./types"

/**
 * Custom hook to extract QuickAnswers-specific analytics properties with memoization.
 * Only recomputes when primitive analytics values change.
 *
 * Note: Dashboard properties (modelId, instrumentId, etc.) are inherited
 * automatically through provider nesting - they should NOT be extracted here.
 *
 * @param quickAnswersContext - The quick answers context value
 * @returns Memoized quick answers analytics properties
 */
export function useExtractQuickAnswersContextProperties(
  quickAnswersContext: Partial<IQuickAnswersContextValue>,
) {
  const question = quickAnswersContext.question

  // Return memoized object depending only on primitive value
  return useMemo(
    () => ({
      question,
    }),
    [question],
  )
}
